enum MoreDetailsModalSections {
  PriceDetails = 'price-details',
  NewPrice = 'new-price',
  GreatDeal = 'great-deal',
  Availability = 'availability',
  EvTax = 'ev-tax'
}

export default MoreDetailsModalSections;
